import { createSlice } from '@reduxjs/toolkit';
import { ServerError } from 'shared/types';
import { cancelAndRefundOrder, confirmOrderDelivery, confirmOrderShipping, createOrderDelivery, getOrderDeliveries, getOreders, returnOrder, updateOrderDelivery } from 'store/actions/oreders-action';
import { OrdersState } from 'store/types';

const initialState: OrdersState = {
  orders: [],
  delivery: null,
  loading: {
    getOrders: false,
    canceledOrder: false,
    shippedOrder: false,
    deliveredOrder: false,
    returnedOrder: false,
    getDelivery: false,
    updateDelivery: false,
  },
  error: null,
};

const oredersReducer = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ============ GET ORDERS ============ //
      .addCase(getOreders.pending, (state) => {
        state.loading.getOrders = true;
        state.error = null;
      })
      .addCase(getOreders.fulfilled, (state, { payload }) => {
        state.loading.getOrders = false;
        state.orders = payload;
      })
      .addCase(getOreders.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.getOrders = false;
        state.error = action.payload.message;
      })
      // ============ CANCEL ORDER ============ //
      .addCase(cancelAndRefundOrder.pending, (state) => {
        state.loading.canceledOrder = true;
        state.error = null;
      })
      .addCase(cancelAndRefundOrder.fulfilled, (state, { payload }) => {
        state.loading.canceledOrder = false;
        for (let i = 0; i < state.orders.length; i++) {
          if (state.orders[i].orderId === payload.orderId) {
            state.orders[i] = payload;
            break;
          }
        }
      })
      .addCase(cancelAndRefundOrder.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.canceledOrder = false;
        state.error = action.payload.message;
      })
      // ============ CONFIRM ORDER SHIPPING ============ //
      .addCase(confirmOrderShipping.pending, (state) => {
        state.loading.shippedOrder = true;
        state.error = null;
      })
      .addCase(confirmOrderShipping.fulfilled, (state, { payload }) => {
        state.loading.shippedOrder = false;
        for (let i = 0; i < state.orders.length; i++) {
          if (state.orders[i].orderId === payload.orderId) {
            state.orders[i] = payload;
            break;
          }
        }
      })
      .addCase(confirmOrderShipping.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.shippedOrder = false;
        state.error = action.payload.message;
      })
      // ============ CONFIRM ORDER DELIVERY ============ //
      .addCase(confirmOrderDelivery.pending, (state) => {
        state.loading.deliveredOrder = true;
        state.error = null;
      })
      .addCase(confirmOrderDelivery.fulfilled, (state, { payload }) => {
        state.loading.deliveredOrder = false;
        for (let i = 0; i < state.orders.length; i++) {
          if (state.orders[i].orderId === payload.orderId) {
            state.orders[i] = payload;
            break;
          }
        }
      })
      .addCase(confirmOrderDelivery.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.deliveredOrder = false;
        state.error = action.payload.message;
      })
      // ============ RETURN ORDER ============ //
      .addCase(returnOrder.pending, (state) => {
        state.loading.returnedOrder = true;
        state.error = null;
      })
      .addCase(returnOrder.fulfilled, (state, { payload }) => {
        state.loading.returnedOrder = false;
        for (let i = 0; i < state.orders.length; i++) {
          if (state.orders[i].orderId === payload.orderId) {
            state.orders[i] = payload;
            break;
          }
        }
      })
      .addCase(returnOrder.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.returnedOrder = false;
        state.error = action.payload.message;
      })
      // ============ GET ORDER DELIVERY ============ //
      .addCase(getOrderDeliveries.pending, (state) => {
        state.loading.getDelivery = true;
        state.error = null;
      })
      .addCase(getOrderDeliveries.fulfilled, (state, { payload }) => {
        state.loading.getDelivery = false;
        state.delivery = payload?.pop() || null;
      })
      .addCase(getOrderDeliveries.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.getDelivery = false;
        state.error = action.payload.message;
      })
      // ============ UPDATE ORDER DELIVERY ============ //
      .addCase(updateOrderDelivery.pending, (state) => {
        state.loading.updateDelivery = true;
        state.error = null;
      })
      .addCase(updateOrderDelivery.fulfilled, (state, { payload }) => {
        state.loading.updateDelivery = false;
        state.delivery = payload;
      })
      .addCase(updateOrderDelivery.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.updateDelivery = false;
        state.error = action.payload.message;
      })

      // ============ CREATE ORDER DELIVERY ============ //
      .addCase(createOrderDelivery.pending, (state) => {
        state.loading.updateDelivery = true;
        state.error = null;
      })
      .addCase(createOrderDelivery.fulfilled, (state, { payload }) => {
        state.loading.updateDelivery = false;
        state.delivery = payload;
      })
      .addCase(createOrderDelivery.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading.updateDelivery = false;
        state.error = action.payload.message;
      })
  },
});

// export const {  } = oredersReducer.actions;
export default oredersReducer.reducer;
